import { ApiMethod } from 'services/api/instance';

import { useRestQuery, RestQueryHookOptions } from 'utils/hooks/api/useRestQuery';
import { useRestMutation, UseRestMutationOptions } from 'utils/hooks/api/useRestMutation';

export const GET_TEMPLATE_DIFF_URL = '/templates/diff.json';
export const POST_RESTORE_TEMPLATE_CONTENT_URL = '/templates/updateTemplateContentId';

export const useGetTemplateDiff = (
  searchParamsTemplateId: string,
  searchParamsContentIdLeft: string,
  searchParamsContentIdRight: string,
  options?: RestQueryHookOptions,
) =>
  useRestQuery(
    GET_TEMPLATE_DIFF_URL,
    {
      templateId: searchParamsTemplateId,
      contentIdLeft: searchParamsContentIdLeft,
      contentIdRight: searchParamsContentIdRight,
    },
    options,
  );

export const usePostRestoreTemplateContent = (options?: UseRestMutationOptions) =>
  useRestMutation(POST_RESTORE_TEMPLATE_CONTENT_URL, ApiMethod.post, options);
